import api from './api';

const productionService = {
  // Get all production records
  getAllProduction: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.quality_grade) params.append('quality_grade', filters.quality_grade);
    
    const response = await api.get(`/api/production?${params.toString()}`);
    return response.data;
  },

  // Get production by ID
  getProductionById: async (id) => {
    const response = await api.get(`/api/production/${id}`);
    return response.data;
  },

  // Create production record
  createProduction: async (productionData) => {
    const response = await api.post('/api/production', productionData);
    return response.data;
  },

  // Update production record
  updateProduction: async (id, productionData) => {
    const response = await api.put(`/api/production/${id}`, productionData);
    return response.data;
  },

  // Delete production record
  deleteProduction: async (id) => {
    const response = await api.delete(`/api/production/${id}`);
    return response.data;
  },

  // Get statistics
  getStats: async (period = 'week') => {
    const response = await api.get(`/api/production/stats?period=${period}`);
    return response.data;
  },

  // Get weekly production (for chart)
  getWeekly: async () => {
    const response = await api.get('/api/production/weekly');
    return response.data;
  },

  // Get monthly production (for chart)
  getMonthly: async () => {
    const response = await api.get('/api/production/monthly');
    return response.data;
  },
};

export default productionService;